import CryptoJS from 'crypto-js';

export const findOnArray = (value, arr = [], field) => {
  const rec = arr.find((i) => i.value === value);
  if (field) {
    return rec?.[field] || null;
  }
  return rec || null;
};

export const summarizer = (arr = [], field) =>
  arr?.length &&
  Number(
    arr
      ?.map((i) => i[field])
      ?.reduce((prev, next) => prev + next)
      ?.toFixed(2)
  );

export const encryptURL = (word, key = 'E-Solution') => {
  let encJson = CryptoJS.AES.encrypt(JSON.stringify(word), key).toString();
  let encData = CryptoJS.enc.Base64.stringify(CryptoJS.enc.Utf8.parse(encJson));
  return encData;
};

export const decryptURL = (word, key = 'E-Solution') => {
  let decData = CryptoJS.enc.Base64.parse(word).toString(CryptoJS.enc.Utf8);
  let bytes = CryptoJS.AES.decrypt(decData, key).toString(CryptoJS.enc.Utf8);
  try {
    const a = JSON.parse(bytes);
    return a;
  } catch (error) {
    return null;
  }
};

export const status = {
  LOTES: { icon: 'widgets', tooltip: 'Lote em progresso' },
  SEPARACAO: { icon: 'call_split', tooltip: 'Separação em progresso' },
  EMBALAGEM: { icon: 'redeem', tooltip: 'Embalagem em progresso' },
  VOLUME: { icon: 'inventory', tooltip: 'Volume em progresso' },
  PENDENTE: { icon: '', tooltip: 'Pendente' },
  'SEM SALDO': { icon: 'priority_high', tooltip: 'Item indisponível' },
  RECEBIMENTO: { icon: 'checklist_rtl', tooltip: 'Conferência em progresso' },
  ARMAZENAGEM: { icon: 'forklift', tooltip: 'Lote em progresso' },
  FINALIZADO: { icon: 'done', tooltip: 'Lote finalizado' },
};

export const generateUUID = (arr = []) => {
  const generator = () => {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
      const r = (Math.random() * 16) | 0;
      const v = c === 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  };

  let uuid = generator();

  return arr.some((a) => a?.uuid === uuid) ? generateUUID(arr) : uuid;
};
